var MultiEditModal = require("src/client-ts/containers/Estimation/ComponentsView/EditMultipleComponentsModal");

exports.multiEditModal = MultiEditModal.EditMultipleComponentsModal;
